import React, { useState, useEffect, useRef } from 'react';
import axios from '../api/axiosConfig';

const CargarPagoImpuestoModal = ({ isOpen, onClose, tramite, onPaymentSuccess }) => {
  const [liquidacionFile, setLiquidacionFile] = useState(null);
  const [soportePagoFile, setSoportePagoFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [manualValue, setManualValue] = useState('');

  const liquidacionInputRef = useRef(null);
  const soportePagoInputRef = useRef(null);

  useEffect(() => {
    if (tramite) {
      setManualValue('');
      setLiquidacionFile(null);
      setSoportePagoFile(null);
      setError('');
    }
  }, [tramite]);

  if (!isOpen || !tramite) return null;

  const handleLiquidacionChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== 'application/pdf') {
        setError('La liquidación debe ser un archivo PDF');
        setLiquidacionFile(null);
        return;
      }
      setLiquidacionFile(file);
      setError('');
    }
  };

  const handleSoporteChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== 'application/pdf') {
        setError('El soporte de pago debe ser un archivo PDF');
        setSoportePagoFile(null);
        return;
      }
      setSoportePagoFile(file);
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!liquidacionFile && !soportePagoFile && !manualValue) {
      setError('Ingrese el valor pagado o adjunte al menos un documento (Liquidación o Soporte de Pago).');
      return;
    }

    setLoading(true);
    setError('');

    const formData = new FormData();
    if (liquidacionFile) {
      formData.append('liquidacion', liquidacionFile);
    }
    if (soportePagoFile) {
      formData.append('soporte_pago', soportePagoFile);
    }
    if (manualValue) {
      formData.append('manual_value', manualValue);
    }

    try {
      const response = await axios.post(`/api/impuestos/${tramite.id}/pagar`, formData);
      
      onPaymentSuccess(response.data);
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || 'Error al procesar los documentos de impuesto');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '580px', width: '92%' }}>
        <button className="modal-close" onClick={onClose}>&times;</button>
        <h2 style={{ marginBottom: '5px' }}>🏛️ Gestión de Impuesto del Trámite</h2>
        <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '20px' }}>
          Trámite #{tramite.id} - Placa: <strong>{tramite.plate || 'Sin Placa'}</strong>
        </p>

        <form onSubmit={handleSubmit}>
          {error && (
            <div className="error-message" style={{ marginBottom: '15px', color: '#dc2626', background: '#fef2f2', padding: '10px 14px', borderRadius: '6px', fontSize: '13px' }}>
              {error}
            </div>
          )}

          {/* 1. Liquidación de Impuesto */}
          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#334155', fontSize: '13px' }}>
              📄 1. Liquidación de Impuesto (Factura / Cobro)
            </label>
            <div 
              className="file-drop-zone"
              onClick={() => liquidacionInputRef.current?.click()}
              style={{
                border: '2px dashed #cbd5e1',
                borderRadius: '8px',
                padding: '16px 14px',
                textAlign: 'center',
                cursor: 'pointer',
                backgroundColor: liquidacionFile ? '#f0fdf4' : '#f8fafc',
                borderColor: liquidacionFile ? '#22c55e' : '#cbd5e1',
                transition: 'all 0.2s ease'
              }}
            >
              <input 
                type="file" 
                ref={liquidacionInputRef} 
                onChange={handleLiquidacionChange} 
                accept=".pdf" 
                style={{ display: 'none' }} 
              />
              
              {liquidacionFile ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: '13px', color: '#15803d', fontWeight: '600' }}>
                    ✓ {liquidacionFile.name} ({(liquidacionFile.size / 1024 / 1024).toFixed(2)} MB)
                  </span>
                  <button 
                    type="button" 
                    onClick={(e) => { e.stopPropagation(); setLiquidacionFile(null); }}
                    style={{ background: 'none', border: 'none', color: '#ef4444', fontSize: '12px', cursor: 'pointer', textDecoration: 'underline' }}
                  >
                    Quitar
                  </button>
                </div>
              ) : (
                <div>
                  <span style={{ fontSize: '13px', color: '#475569', fontWeight: '500' }}>
                    📥 Adjuntar PDF de Liquidación (Opcional)
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* 2. Soporte / Comprobante de Pago */}
          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#334155', fontSize: '13px' }}>
              💳 2. Soporte de Pago de la Liquidación (Comprobante / Recibo)
            </label>
            <div 
              className="file-drop-zone"
              onClick={() => soportePagoInputRef.current?.click()}
              style={{
                border: '2px dashed #cbd5e1',
                borderRadius: '8px',
                padding: '16px 14px',
                textAlign: 'center',
                cursor: 'pointer',
                backgroundColor: soportePagoFile ? '#f0fdf4' : '#f8fafc',
                borderColor: soportePagoFile ? '#22c55e' : '#cbd5e1',
                transition: 'all 0.2s ease'
              }}
            >
              <input 
                type="file" 
                ref={soportePagoInputRef} 
                onChange={handleSoporteChange} 
                accept=".pdf" 
                style={{ display: 'none' }} 
              />
              
              {soportePagoFile ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: '13px', color: '#15803d', fontWeight: '600' }}>
                    ✓ {soportePagoFile.name} ({(soportePagoFile.size / 1024 / 1024).toFixed(2)} MB)
                  </span>
                  <button 
                    type="button" 
                    onClick={(e) => { e.stopPropagation(); setSoportePagoFile(null); }}
                    style={{ background: 'none', border: 'none', color: '#ef4444', fontSize: '12px', cursor: 'pointer', textDecoration: 'underline' }}
                  >
                    Quitar
                  </button>
                </div>
              ) : (
                <div>
                  <span style={{ fontSize: '13px', color: '#475569', fontWeight: '500' }}>
                    📥 Adjuntar PDF de Soporte de Pago (Opcional)
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Valor Pagado */}
          <div className="form-group" style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#334155', fontSize: '13px' }}>
              💰 Valor Pagado del Impuesto ($)
            </label>
            <input 
              type="text" 
              className="form-input" 
              placeholder="Ej: 62000"
              value={manualValue}
              onChange={(e) => setManualValue(e.target.value)}
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
            />
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
            <button 
              type="button" 
              className="btn-secondary" 
              onClick={onClose}
              disabled={loading}
            >
              Cancelar
            </button>
            <button 
              type="submit" 
              className="btn-primary" 
              disabled={loading}
              style={{ background: '#10b981', borderColor: '#059669' }}
            >
              {loading ? 'Guardando...' : 'Guardar Documentos'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CargarPagoImpuestoModal;
